<template>
  <v-container fluid class="px-0">
    <div class="creativeproject-page">
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-card class="folder-card ma-1">
            <v-card-text class="pa-5 pt-0">
              <v-row justify="center" style="margin-top: 5px;">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col md="11">
                      <p class="text-h5">{{ initvalue.projectname }}</p>
                    </v-col>
                    <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="1">
                  <div style="align-content: top;">
                    <v-img
                        v-if="initvalue.projectimage" 
                        v-bind:src="initvalue.projectimage"
                        max-height="80"
                        max-width="80"
                        contain
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Date</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Type</span></td>
                          <td>{{ initvalue.projecttype }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Marketing Rep</span></td>
                          <td>{{  }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Complete By</span></td>
                          <td>{{ new Date(initvalue.projectdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1">
                <v-card-text class="pa-5 pt-0">
                  <v-tabs color="primary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-campaigns'"
                    >
                      Campaigns
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-detail'"
                    >
                      <span>Detail</span>
                      <span style="font-size: 8pt;">{{`${campaignid!=null ? '('+details.filter(detail=>detail.campaignid==campaignid).length+')' : ''}` }}</span>
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-events'"
                    >
                      Events
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="4"
                      :href="'#tab-sales'"
                    >
                      Sales
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="5"
                      :href="'#tab-merchandise'"
                    >
                      Merchandise
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-campaigns'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Campaigns</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="secondary"
                                  @click="isAddCampaign=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="campaignstartdate"
                                sort-desc
                                show-select
                                single-select
                                item-key="_id"
                                v-model="selectedCampaign"
                                :headers="campaignHeaders"
                                :items="data_campaigns"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                              <template v-slot:top>
                                  <v-dialog v-model="isDeleteCampaign" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Campaign? </v-card-title>
                                      <v-card-text>
                                        {{ delete_campaign.campaignname }}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteCampaign = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectCampaign(delete_campaign)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.campaignimage="{ item }">
                                  <v-img
                                    v-bind:src="item.campaignimage"
                                    max-height="60"
                                    max-width="60"
                                  ></v-img>
                                </template>
                                <template v-slot:item.campaignname="{ item }">
                                  <p class="two-line">{{ item.campaignname }}</p>
                                  <p class="two-line">{{ item.campaigntype }}</p>
                                </template>
                                <template v-slot:item.campaignstartdate="{ item }">
                                  {{ new Date(item.campaignstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                                </template>
                                <template v-slot:item.campaignenddate="{ item }">
                                  {{ new Date(item.campaignenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                                </template>                    
                                <template v-slot:item.actions="{ item }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="printCampaignDetails(item)"
                                  >
                                    <v-icon>mdi-printer</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="editCampaignDialog(item)"
                                  >
                                    <v-icon>mdi-pencil</v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="item.campaignstatus=='New'"
                                    icon
                                    color="primary"
                                    @click="deleteCampaignDialog(item)"
                                  >
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="2"
                      :value="'tab-detail'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                    <v-divider></v-divider>
                      <v-row justify="center" style="margin-top: 15px; margin-left: 5px;">
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col md="10">
                                <p class="text-h6">Details</p>
                              </v-col>
                              <v-col md="2" align="right">
                                <v-btn
                                  class="button-shadow"
                                  color="secondary"
                                  @click="isAddDetail=true"
                                >
                                  Add
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-form>
                              <v-data-table
                                sort-by="contentpostdate"
                                sort-desc
                                item-key="_id"
                                :headers="detailHeaders"
                                :items="campaignid!=null ? details.filter(detail=>detail.campaignid==campaignid) : details"
                                :items-per-page="500"
                                :footer-props="footer"
                                class="elevation-0"
                              >
                                <template v-slot:top>
                                  <v-dialog v-model="isDeleteDetail" width="500">
                                    <v-card>
                                      <v-card-title> Delete this Detail? </v-card-title>
                                      <v-card-text>
                                        {{ delete_detail.detailrank }}. {{ delete_detail.campaignid!=null && campaigns.length>0 ? campaigns.find(campaign=>campaign._id == delete_detail.campaignid)['campaignname'] : '' }}
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          outlined
                                          @click="isDeleteDetail = false"
                                          >Cancel</v-btn
                                        >
                                        <v-btn
                                          color="secondary"
                                          class="button-shadow"
                                          @click="deleteProjectDetail(delete_detail)"
                                          >Delete
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </template>
                                <template v-slot:item.detailimage="{ item }">
                                  <div style="vertical-align: top; height: 100%; padding-top: 10px;">
                                    <v-img
                                      v-bind:src="item.detailimage"
                                      max-height="60"
                                      max-width="60"
                                    ></v-img>
                                  </div>
                                </template>  
                                <template v-slot:item.detailbody="{ item }">
                                  <span style="font-weight: bold">{{ item.detailrank }}. {{ item.campaignid!=null && campaigns.length>0 ? campaigns.find(campaign=>campaign._id == item.campaignid)['campaignname'] : '' }}</span>&nbsp;
                                  <p class="two-line" style="font-size: 10pt;" v-html="item.detailbody"></p>
                                </template>
                                <template v-slot:item.userid="{ item }">
                                  <div v-if="item.userid!=undefined" style="vertical-align: top; height: 100%; padding-top: 10px;">
                                    <p class="two-line" style="margin-left: 5px;">
                                  <v-avatar v-if="item.userid!=null && users.length>0" size="30">
                                    <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                                  </v-avatar>
                                  <v-avatar
                                    v-else
                                    color="warning"
                                    size="30">
                                    <p class="two-line"><span class="white--text headline">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                                  </v-avatar>
                                  </p>
                                  <p class="two-line"><span style="margin-left:5px; font-size: 9pt;">{{ item.userid!=null && users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span></p>
                                  </div>
                                </template>     


                                                   
                                <template v-slot:item.actions="{ item }"> 
                                  <div style="vertical-align: top; height: 100%; padding-top: 10px;">
                                    <v-btn
                                      icon
                                      color="primary"
                                      @click="editDetailDialog(item)"
                                    >
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn
                                      icon
                                      color="primary"
                                      @click="deleteDetailDialog(item)"
                                    >
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                  </div>
                                </template>
                              </v-data-table>
                            </v-form>
                          </v-col>
                        </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-dialog
      v-model="isAddCampaign"
      persistent
      width="800px"
      max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Campaign</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="add_campaign.campaignrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="add_campaign.campaignname"
                    label="Name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="campaigntype"
                    v-model="add_campaign.campaigntype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-file-input dense label="File input" v-model="new_campaignphoto" v-on:change="onChangeCampaignPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="['New', 'Active', 'Inactive']"
                    v-model="add_campaign.campaignstatus"
                    placeholder="Status"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="new_campaignstartdate"
                    v-model="new_campaignstartdate"
                    :close-on-content-click="false"
                    :return-value.sync="add_campaign.campaignstartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="add_campaign.campaignstartdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="add_campaign.campaignstartdate"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        single-line hint="Please choose the start date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_campaign.campaignstartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="new_campaignstartdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.new_campaignstartdate.save(add_campaign.campaignstartdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="new_campaignenddate"
                    v-model="new_campaignenddate"
                    :close-on-content-click="false"
                    :return-value.sync="add_campaign.campaignenddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="add_campaign.campaignenddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="add_campaign.campaignenddate"
                        v-on="on"
                        single-line hint="Please choose the end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_campaign.campaignenddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="new_campaignenddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.new_campaignenddate.save(add_campaign.campaignenddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_campaign.campaigndesc"
                    rows=3
                    label="Description"
                    hint="please enter campaign brief"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddCampaign=false; add_campaign={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addProjectCampaignRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="isEditCampaign"
      persistent
      width="800px"
      max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Campaign</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="edit_campaign.campaignrank"
                    v-on:change="onChangeCampaign($event, 'campaignrank')"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_campaign.campaignname"
                    v-on:change="onChangeCampaign($event, 'campaignname')"
                    label="Name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="campaigntype"
                    v-model="edit_campaign.campaigntype"
                    v-on:change="onChangeCampaign($event, 'campaigntype')"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-file-input dense label="File input" v-model="edit_campaignphoto" v-on:change="onChangeEditCampaignPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="['New', 'Active', 'Inactive']"
                    v-model="edit_campaign.campaignstatus"
                    v-on:change="onChangeCampaign($event, 'campaignstatus')"
                    placeholder="Status"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="edit_campaignstartdate"
                    v-model="edit_campaignstartdate"
                    :close-on-content-click="false"
                    :return-value.sync="edit_campaign.campaignstartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="edit_campaign.campaignstartdate"
                        v-on:change="onChangeCampaign($event, 'campaignstartdate')"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:error="errorindex == 1"
                        v-on="on"
                        single-line hint="Please choose the start date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_campaign.campaignstartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="edit_campaignstartdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.edit_campaignstartdate.save(edit_campaign.campaignstartdate); onChangeCampaign(edit_campaign.campaignstartdate, 'campaignstartdate')"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="edit_campaignenddate"
                    v-model="edit_campaignenddate"
                    :close-on-content-click="false"
                    :return-value.sync="edit_campaign.campaignenddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="edit_campaign.campaignenddate"
                        v-on:change="onChangeCampaign($event, 'campaignenddate')"
                        label="End Date"
                        v-bind="attrs"
                        v-on="on"
                        single-line hint="Please choose the end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_campaign.campaignenddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="edit_campaignenddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.edit_campaignenddate.save(edit_campaign.campaignenddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="edit_campaign.campaigndesc"
                    v-on:change="onChangeCampaign($event, 'campaigndesc')"
                    rows=3
                    label="Description"
                    hint="please enter campaign brief"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditCampaign=false; edit_campaign={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editProjectCampaign"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddDetail"
        persistent
        width="1000px"
        max-width="1000px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="1">
                <v-text-field
                  v-model="add_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  dense
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_detail.campaignid"
                      placeholder="Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
              <v-col cols="12" md="6">
                <v-file-input dense label="File input" v-model="detail_file" v-on:change="onChangeDetailPhoto" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="add_detail.detailbody"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addProjectDetailRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
        v-model="isEditDetail"
        persistent
        width="1000px"
        max-width="1000px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Detail</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
              <v-col cols="12" md="1">
                <v-text-field
                  v-model="edit_detail.detailrank"
                  v-on:change="onChangeDetail($event, 'detailrank')"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  dense
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="edit_detail.campaignid"
                      v-on:change="onChangeDetail($event, 'campaignid')"
                      placeholder="Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
              <v-col cols="12" md="6">
                <v-file-input dense label="File input" v-model="detail_file" v-on:change="onChangeDetailEditPhoto" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="edit_detail.detailbody" @text-change="onChangeDetail(edit_detail.detailbody, 'detailbody')"></vue-editor>
              </v-col>
            </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditDetail=false; edit_detail={}; change_detail={};"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editProjectDetail"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddAd"
        persistent
        width="800px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add Ad Set</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4"
                      :items="data_campaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_ad.mktcampaignid"
                      placeholder="Marketing Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4"
                      :items="posts.filter(post=>post.campaignid==add_ad.mktcampaignid).map(x => {return {text: `${x.posttitle} (${formatStdDate(x.postdate)})`, value: x._id};})"
                      v-model="add_ad.postid"
                      placeholder="Post"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="add_ad.adset_name"
                      label="Ad Name"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      class="mb-4"
                      :items="adcampaigns.map(x => {return {text: x.campaignname, value: x._id};})"
                      v-model="add_ad.campaignid"
                      placeholder="Ad Campaign"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="new_start_time"
                      v-model="new_start_time"
                      :close-on-content-click="false"
                      :return-value.sync="add_ad.start_time"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_ad.start_time"
                          label="Start Date"
                          v-bind="attrs"
                          v-bind:value="add_ad.start_time"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the start date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_ad.start_time"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_start_time = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_start_time.save(add_ad.start_time)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="new_end_time"
                      v-model="new_end_time"
                      :close-on-content-click="false"
                      :return-value.sync="add_ad.end_time"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="add_ad.end_time"
                          label="End Date"
                          v-bind="attrs"
                          v-bind:value="add_ad.end_time"
                          v-bind:error="errorindex == 1"
                          v-on="on"
                          dense
                          single-line hint="Please choose the start date">
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="add_ad.end_time"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="new_end_time = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.new_end_time.save(add_ad.end_time)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['POST_ENGAGEMENT', 'REACH', 'IMPRESSIONS', 'PAGE_LIKES']"
                      v-model="add_ad.optimization_goal"
                      v-bind:error="errorindex == 1"
                      placeholder="Type"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      class="mb-4"
                      :items="['POST_ENGAGEMENT', 'IMPRESSIONS', 'PAGE_LIKES']"
                      v-model="add_ad.billing_event"
                      v-bind:error="errorindex == 1"
                      placeholder="Billing Event"
                      dense
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="add_ad.lifetime_budget"
                      label="Ad Budget"
                      required
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="add_ad.targeting"
                      rows=5
                      label="Targeting"
                      hint="please enter tageting"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddAd=false; add_ad={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addMarketingAdRequest"
                :loading="isSubmitting"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isApproveContent"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send Content for Approval</span>
            </v-card-title>
            <v-card-text>
              {{ approve_content.detailtitle }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="approve_content.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isApproveContent=false; approve_content={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="approve_content.confirm!=='Send'"
                @click="approveProjectDetailRequest"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isPostContent"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Post Content</span>
            </v-card-title>
            <v-card-text>
              {{ post_content.detailtitle }}
            </v-card-text>
            <v-card-text>
              This action will post to a social detail platform. 
              <br>Consumers will see the content on a public page. 
              <br>Check content for errors and correctness prior to posting.  
            </v-card-text>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="post_content.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Post'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isPostContent=false; post_content={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="post_content.confirm!=='Post'"
                @click="postProjectDetailRequest"
                :loading="isPosting"
              >
                Post
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isViewPost"
        persistent
        width="550px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">View Post</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <iframe :src="`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2F${view_post.pageid}%2Fposts%2F${view_post.postid}%2F&width=500&show_text=true&height=628`" width="500" height="628" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-detail; picture-in-picture; web-share"></iframe>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isViewPost=false; view_post={}"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';

export default {
  name: "Profile",
  components: {
    VueEditor
  },
  data() {
    return {
      error: undefined,
      errortag: false,
      errortime: false,
      errorindex: undefined,
      isPosting: false,
      isSubmitting: false,
      isDeleting: false,
      isAddCampaign: false,
      isAddAd: false,
      isAddDetail: false,
      isViewPost: false,

      isEditCampaign: false,
      isEditDetail: false,
      isEditPost: false,
      isEditEvent: false,

      isApproveContent: false,
      isPostContent: false,
      isDeleteCampaign: false,
      isDeleteDetail: false,
      isDeletePost: false,


      uploadtype: 'File',
      detail_file: null,
      message_file: null,
      userid: null,
      new_campaignphoto: null,
      new_campaignstartdate: null,
      new_campaignenddate: null,
      new_detailphoto: null,
      new_start_time: null,
      new_end_time: null,


      edit_campaignphoto: null,
      edit_detailphoto: null,
      edit_campaignpostdate: null,
      edit_campaignstartdate: null,
      edit_campaignenddate: null,

      initvalue: {},
      
      approve_content: {},
      post_content: {},
      view_post: {},
      
      delete_campaign: {},
      delete_detail: {},
      delete_post: {},

      add_ad: {},
      add_campaign: {},
      add_detail: {},
      add_event: {},
      add_merchandise: {},

      edit_campaign: {},
      edit_detail: {},
      edit_event: {},
      edit_merchandise: {},
      change_campaign: {},
      change_detail: {},
      change_event: {},
      change_merchandise: {},
      
      selectedCampaign: [],
      mktprojects: [],
      campaigns: [],
      posts: [],
      adcampaigns: [],
      adsets: [],

      details: [],
      times: [],
      users: [],
      campaigntype: ['Events', 'Merchandise', 'Print Detail', 'Photograpy', 'Videography' ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      formatStdDate: formatStdDate,
      campaignHeaders: [
        { text: "Image", value: "campaignimage", width: "10%" }, 
        { text: "Name", value: "campaignname" },
        { text: "Start Date", value: "campaignstartdate", width: "10%" },
        { text: "End Date", value: "campaignenddate", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      detailHeaders: [
        { text: "Image", value: "detailimage", width: "10%"}, 
        { text: "Detail", value: "detailbody" },
        { text: "Created By", value: "userid", width: "10%"  },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      postHeaders: [
        { text: "Post Date", value: "postdate", width: "18%" },
        { text: "Post Type", value: "posttype", width: "20%" }, 
        { text: "Post Title", value: "posttitle", width: "20%"  },         
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      adHeaders: [
        { text: "Ad Date", value: "start_time", width: "18%" },
        { text: "Name & Id", value: "adset_name", width: "20%" }, 
        { text: "Goal & Event", value: "optimization_goal", width: "15%" },
        { text: "Budget", value: "lifetime_budget", width: "15%" }, 
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],

      timeHeaders: [
        { text: "Start", value: "timestart", width: "20%"},
        { text: "End", value: "timeend", width: "20%" },
        { text: "Work Hours", value: "timehour", width: "10%" },
        { text: "Desc", value: "timedesc" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      fileHeaders: [
        { text: "Type", value: "filetype", width: "10%" }, 
        { text: "Name", value: "detailtitle" },
        { text: "Size", value: "filesize", width: "10%" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
    };
  },
  computed: {
    ...mapState('Language', ['languages']),
    campaignid () {
      return this.selectedCampaign.length>0 ? this.selectedCampaign[0]._id : null;
    },
    data_details () {
      if(this.details.length==0) return [];
      let results = [
        //...this.details.filter(detail=>detail.campaignid==this.campaignid),
        ...this.details,
      ]
      return results;
    },
    data_campaigns () {
      if(this.campaigns.length==0) return [];
      
      let results = this.campaigns.filter(campaign=>this.campaigntype.indexOf(campaign.campaigntype) > -1);
      return results;
    },
  },
  methods: {
    ...mapActions('MarketAd', ["insertMarketAdsetRequest"]),
    ...mapActions('MarketCampaign', [
      'deleteProjectCampaignRequest', 
      'insertProjectCampaignRequest', 'insertProjectCampaignWithImageRequest', 
      'updateProjectCampaignRequest', 'updateProjectCampaignWithImageRequest']),
    ...mapActions('MarketDetail', [
      'deleteProjectDetailRequest', 
      'insertProjectDetailRequest', 'insertProjectDetailWithImageRequest', 
      'updateProjectDetailRequest', 'updateProjectDetailWithImageRequest', 'updateMarketDetailPendingRequest']),
    ...mapActions('MarketPost', ["insertMarketPostRequest", "deleteProjectPostRequest"]),

    ...mapActions('MarketProject', ['getCreativeProjects', 
                    'insertProjectMessageRequest', 'insertProjectSystemMessageRequest', 'insertProjectSystemMessageWithFileRequest', 
                    'insertProjectMessageWithFileRequest',
                    'insertProjectTimeRequest',
                    'deleteProjectMessageRequest']),
    ...mapActions('User', ['getUsersAllRequest']),
    checkError(){
      if(!this.add_time.startdate){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.add_time.starthour){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.add_time.startminute){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.add_time.startampm){
        this.errortag = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.add_time.enddate){
        this.errortag = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.add_time.endhour){
        this.errortag = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.add_time.endminute){
        this.errortag = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.add_time.endampm){
        this.errortag = true;
        this.errorindex = 7;
        return false;
      }
      if(!this.add_time.projectprogress){
        this.errortag = true;
        this.errorindex = 8;
        return false;
      }

      this.errorindex = -1;
      return true;
    },
    checkError2(){
      if(this.uploadtype=='File' && this.detail_file==null){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(this.uploadtype=='Link' && !this.add_detail.detaillink){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_detail.detailtype){
        this.errortag = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_detail.detailtitle){
        this.errortag = true;
        this.errorindex = 13;
        return false;
      }
      if(this.add_detail.detailtype=='Final File' && this.times.length==0){
        this.errortime = true;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(!this.add_message.messagetext){
        this.errortag = true;
        this.errorindex = 21;
        return false;
      }
      this.errortime = false;
      this.errorindex = -1;
      return true;
    },
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'Dashboard' });
    },
    async addProjectCampaignRequest() {
      let result;
      this.isAddCampaign = false;
      this.add_campaign.projectid = this.initvalue._id;
      if(this.add_campaign.imagefile!==null && this.add_campaign.imagefile!==undefined) result = await this.insertProjectCampaignWithImageRequest(this.add_campaign);
      else result = await this.insertProjectCampaignRequest(this.add_campaign);
      this.projectcampaigns.push(result);
      this.add_campaign = {};
      this.new_campaignphoto = null;
    },
    async addProjectDetailRequest() {
      let result;
      this.isAddDetail = false;
      this.add_detail.projectid = this.initvalue._id;
      if(this.add_detail.imagefile!==null && this.add_detail.imagefile!==undefined) result = await this.insertProjectDetailWithImageRequest(this.add_detail);
      else result = await this.insertProjectDetailRequest(this.add_detail);
      this.details.push(result);
      this.add_detail = {};
      this.new_detailphoto = null;
    },
    async addMarketingAdRequest() {
      if(this.isSubmitting==true) return;
      this.isSubmitting= true;
      this.add_ad.projectid = this.initvalue._id;
      let result = await this.insertMarketAdsetRequest(this.add_ad);
      this.adsets.push(result);
      this.isSubmitting = false;
      this.isAddAd = false;
      this.add_ad = {};
    },
    approveContentDialog(item) {
      this.isApproveContent = true;
      this.approve_content = {
        _id: item._id,
        detailtitle: item.detailtitle,
      };
    },
    printCampaignDetails(item) {
      let campaign = Object.assign({}, item);
      let details = this.initvalue.details.filter(detail=>detail.campaignid==item._id);
      campaign.details = Object.assign([], details);
      campaign.companyid = this.initvalue.companyid;
      campaign['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'MarketProjectPrint', params: campaign });
    },
    postContentDialog(item) {
      this.isPostContent = true;
      this.post_content = {
        _id: item._id,
        detailtitle: item.detailtitle,
      };
    },
    async approveProjectDetailRequest() {
      this.isApproveContent = false;
      this.approve_content.contentid = this.approve_content._id;
      let result = await this.updateMarketDetailPendingRequest(this.approve_content);
      let index = this.details.findIndex((x) => x._id == result._id);
      this.details.splice(index, 1, result);
      this.approve_content = {};
    },
    async postProjectDetailRequest() {
      if(this.isPosting==true) return;
      this.isPosting= true;
      this.post_content.contentid = this.post_content._id;
      let result = await this.insertMarketPostRequest(this.post_content);
      this.posts.push(result);
      this.isPosting= false;
      this.isPostContent = false;
    },
    deleteCampaignDialog(item) {
      this.isDeleteCampaign = true;
      this.delete_campaign = {
        _id: item._id,
        campaignname: item.campaignname,
      };
    },
    deleteDetailDialog(item) {
      this.isDeleteDetail = true;
      this.delete_detail = {
        _id: item._id,
        detailrank: item.detailrank,
        campaignid: item.campaignid,
      };
    },
    deletePostDialog(item) {
      this.isDeletePost = true;
      this.delete_post = {
        _id: item._id,
        posttitle: item.posttitle,
      };
    },
    async deleteProjectCampaign(payload) {
      this.isDeleteCampaign = false;
      let response = await this.deleteProjectCampaignRequest(payload);
      let index = this.campaigns.findIndex((trans) => trans._id == response._id);
      this.campaigns.splice(index, 1);
    },
    async deleteProjectDetail(payload) {
      this.isDeleteDetail = false;
      let response = await this.deleteProjectDetailRequest(payload);
      let index = this.details.findIndex((trans) => trans._id == response._id);
      this.details.splice(index, 1);
    },
    async deleteProjectPost(payload) {
      if(this.isDeleting==true) return;
      this.isDeleting= true;
      let response = await this.deleteProjectPostRequest(payload);
      let index = this.posts.findIndex((trans) => trans._id == response._id);
      this.posts.splice(index, 1);
      this.isDeletePost = false;
      this.isDeleting = false;
    },
    async deleteProjectMessage(payload) {
      let response = await this.deleteProjectMessageRequest(payload);
      let index = this.messages.findIndex((trans) => trans._id == response._id);
      this.messages.splice(index, 1);
    },
    editDetailDialog(item) {
      this.edit_detail = Object.assign({}, item);
      this.change_detail = {};
      this.isEditDetail = true;
    },
    editCampaignDialog(item) {
      this.edit_campaign = Object.assign({}, item);
      this.change_campaign = {};
      this.edit_campaign.campaignstartdate = formatStdDate(this.edit_campaign.campaignstartdate);
      this.edit_campaign.campaignenddate = formatStdDate(this.edit_campaign.campaignenddate);
      this.change_campaign = {};
      this.isEditCampaign = true;
    },
    async editProjectCampaign() {
      let response;
      this.isEditCampaign = false;
      this.change_campaign.campaignid = this.edit_campaign._id;
      
      if(this.change_campaign.imagefile!==null && this.change_campaign.imagefile!==undefined) response = await this.updateProjectCampaignWithImageRequest(this.change_campaign);
      else response = await this.updateProjectCampaignRequest(this.change_campaign);
      let index = this.campaigns.findIndex((x) => x._id == response._id);
      this.campaigns.splice(index, 1, response);
      this.edit_campaign = {};
      this.edit_campaignphoto = null;
    },
    async editProjectDetail() {
      let response;
      this.isEditDetail = false;
      this.change_detail.detailid = this.edit_detail._id;
      
      console.log(this.change_detail)
      if(this.change_detail.imagefile!==null && this.change_detail.imagefile!==undefined) response = await this.updateProjectDetailWithImageRequest(this.change_detail);
      else response = await this.updateProjectDetailRequest(this.change_detail);
      let index = this.details.findIndex((x) => x._id == response._id);
      this.details.splice(index, 1, response);
      this.edit_detail = {};
      this.change_detail = {};
      this.edit_detailphoto = null;
    },
    onChangeMessageFile(file) {
      if (!file) this.message_file.file = null;
      else this.message_file = file;
    },
    onChangeCampaignPhoto(file) {
      if (!file) return;
      this.add_campaign.imagefile = file;
      this.add_campaign.imagename = file.name;
    },
    onChangeEditCampaignPhoto(file) {
      if (!file) return;
      this.change_campaign.imagefile = file;
      this.change_campaign.imagename = file.name;
    },
    onChangeEditContentPhoto(file) {
      if (!file) return;
      this.change_detail.imagefile = file;
      this.change_detail.imagename = file.name;
    },
    onChangeDetailPhoto(file) {
      if (!file) return;
      this.add_detail.imagefile = file;
      this.add_detail.imagename = file.name;
    },
    onChangeDetailEditPhoto(file) {
      if (!file) return;
      this.change_detail.imagefile = file;
      this.change_detail.imagename = file.name;
    },
    onChangeCampaign(value, field){
      this.change_campaign[field] = value;
    },
    onChangeDetail(value, field){
      this.change_detail[field] = value;
    },
    viewPostDialog(item) {
      this.isViewPost = true;
      this.view_post = {
        _id: item._id,
        posturl: item.posturl,
        pageid: item.post_id.split("_")[0],
        postid: item.post_id.split("_")[1],
      };
    },
    async insertMessage() {
      if(!this.checkError3()) return;
      this.isAddCampaign = false;
      this.add_message.id = this.initvalue._id;
      let result;
      if(this.isSystemEnabled==true){
        if(this.message_file!=null){
          this.add_message.file = this.message_file;
          this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
          result = await this.insertProjectSystemMessageWithFileRequest(this.add_message);
        } 
        else {
          this.add_detail.file = null;
          result = await this.insertProjectSystemMessageRequest(this.add_message);
        } 
      }
      else if(this.message_file!=null){
        console.log(this.message_file)
        this.add_message.file = this.message_file;
        this.add_message.filename = this.message_file!=null ? this.message_file.name : '';
        result = await this.insertProjectMessageWithFileRequest(this.add_message);
      } 
      else {
        this.add_detail.file = null;
        result = await this.insertProjectMessageRequest(this.add_message);
      } 
      this.messages = [result, ...this.messages];
      this.add_message = {};
      this.message_file = null;

    },
  },
  async created() {
    this.userid = localStorage.getItem('userid');
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.replace({ name: "MarketProjectList" });
    this.campaigns = this.initvalue.campaigns;
    this.details = this.initvalue.details;
    this.posts = this.initvalue.posts;
    this.adcampaigns = this.initvalue.adcampaigns;
    this.adsets = this.initvalue.adsets;

    if(this.users.length==0) this.users = await this.getUsersAllRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
